import { render } from "./SettingsLogo.vue?vue&type=template&id=a194ca22&ts=true"
import script from "./SettingsLogo.vue?vue&type=script&lang=ts"
export * from "./SettingsLogo.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__